import React from 'react'
import PropTypes from 'prop-types'
import ClassificationChips from '../common/ClassificationChips'

function Departments({ departments }) {
  return <ClassificationChips items={departments} />
}

Departments.propTypes = {
  departments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    }).isRequired
  ).isRequired
}

export default Departments
